import { Box, Button, ButtonGroup, Grid, MenuItem } from "@material-ui/core";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useStyleDisplay } from "../helpers/useStyleDisplay";
import { useStyles, useZoomStyle } from "./helpers/DisplayQueueEvent";
import SelectDropOtions from "../../../components/SelectDropOtions";
import { Add, Remove } from "@material-ui/icons";
import { getBuildingSettingOption } from "../../../../api/buildingSettingApi";
import { getTextSetting } from "../../../../api/textSettingApi";
import RoomDetails from "./components/RoomDetails";
import MenuPopoverRoom from "./components/MenuPopoverRoom";
import { getQueueRoom } from "../../../../api/queueApi";
import DoctorQueueDisplayDateTime from "./DoctorQueueDisplayDateTime";

const initialDataNodeRoom = [
    { nodeId: 1, isShow: false, roomObj: {} },
    { nodeId: 2, isShow: false, roomObj: {} },
    { nodeId: 3, isShow: false, roomObj: {} },
];

const synth = window.speechSynthesis;

export default function DoctorQueueDisplay() {
    const classs = useStyles();
    const classsDisplay = useStyleDisplay();
    const [valueZoom, setValueZoom] = useState(1);
    const classZoom = useZoomStyle(valueZoom);

    // ref
    const controllerRef = useRef(null);

    // component state
    const [nodeIdBoxRoom, setNodeIdBoxRoom] = useState(initialDataNodeRoom);
    const [dataRoom, setDataRoom] = useState([]);
    const [buildingId, setBuildingId] = useState("");
    const [floorId, setFloorId] = useState("");
    const [option, setOption] = useState({ building: [], floor: [] });
    const [speakTextQueue, setSpeakTextQueue] = useState([]);
    const [movingText, setMovingText] = useState("");

    // text to speach
    const voiceTH = synth.getVoices()?.find(item => item?.lang === "th-TH");
    const voiceEN = synth.getVoices()?.find(item => item?.lang === "en-US");

    // add fontsize
    const incrementFontSize = useCallback(
        type => {
            if (type === "up") {
                return setValueZoom(prev => prev + 0.25);
            }
            if (valueZoom <= 1) {
                if (valueZoom !== 0) {
                    return setValueZoom(prev => prev - 0.25);
                }
                return setValueZoom(0);
            }
            return setValueZoom(prev => prev - 0.25);
        },
        [valueZoom],
    );

    // fetch examination room
    const fetchRoom = useCallback(async (building = null, floor = null) => {
        try {
            const body = {
                builingId: building || 0,
                floorId: floor || 0,
                statusRoom: "0",
            };
            const res = await getQueueRoom(body);
            if (res) {
                setDataRoom(res?.data);
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // function change select option
    const handleChangeSelectOption = useCallback(
        async (type, val) => {
            if (type === "building") {
                setBuildingId(val);
                setFloorId("");
                setDataRoom([]);
            } else if (type === "floor") {
                setFloorId(val);
                await fetchRoom(buildingId, val);
            }
            setNodeIdBoxRoom(initialDataNodeRoom);
        },
        [fetchRoom, buildingId],
    );

    // handle click event
    const handleSelectMenuRoom = useCallback(async result => {
        const node = result?.node;
        const roomObj = result?.roomObj;
        setNodeIdBoxRoom(currentState =>
            currentState.map(obj => {
                return obj.nodeId === node ? { ...obj, isShow: true, roomObj } : obj;
            }),
        );
        setDataRoom(currentState => currentState.filter(room => room?.roomId !== roomObj?.roomId));
    }, []);

    // fetch building setting option
    const fetchBuildingSettingOption = useCallback(async signal => {
        try {
            const buildingSettingOption = await getBuildingSettingOption(signal);
            if (buildingSettingOption) {
                setOption(currentState => ({
                    ...currentState,
                    building: buildingSettingOption?.buildingOption,
                    floor: buildingSettingOption?.floorOption,
                }));
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // fetch text setting
    const fetchTextSetting = useCallback(async signal => {
        try {
            const textSetting = await getTextSetting(signal);
            if (textSetting) {
                setMovingText(textSetting?.text);
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // run only first render
    useEffect(() => {
        controllerRef.current = new AbortController();
        const init = async () => {
            await fetchBuildingSettingOption(controllerRef.current?.signal);
            await fetchTextSetting(controllerRef.current?.signal);
            setNodeIdBoxRoom(initialDataNodeRoom);
        };
        init();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, [fetchBuildingSettingOption, fetchTextSetting]);

    // auto speak
    useEffect(() => {
        if (speakTextQueue.length) {
            const utterance = new SpeechSynthesisUtterance(speakTextQueue[0]?.text);
            utterance.voice = speakTextQueue[0]?.lang === "en" ? voiceEN : voiceTH;
            utterance.rate = 0.5;
            utterance.pitch = 0.6;
            synth.speak(utterance);
        }
        setSpeakTextQueue(currentState => {
            currentState.shift();
            return currentState;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [speakTextQueue]);

    return (
        <div className={`${classs.containerDisplay} ${classZoom().container}`}>
            <div className="h-100 w-100 d-flex flex-column justify-content-between">
                {/* header */}
                <div className="header-title">
                    <Grid container className="align-items-center py-5 shadow-sm">
                        <Grid item xs={12} lg={6} className="px-3 mb-3 mb-xl-0">
                            <DoctorQueueDisplayDateTime />
                        </Grid>
                        <Grid item xs={12} lg={6} className="px-3">
                            <div className="d-flex align-items-stretch w-100">
                                <div className="d-flex flex-column">
                                    <ButtonGroup disableElevation className={`flex-fill ${classs.btnUpsizeFont}`}>
                                        <Button onClick={() => incrementFontSize("down")}>
                                            <Remove />
                                        </Button>
                                        <Button variant="text" className="flex-fill text-show-value text-center">
                                            x{valueZoom}
                                        </Button>
                                        <Button onClick={() => incrementFontSize("up")}>
                                            <Add />
                                        </Button>
                                    </ButtonGroup>
                                </div>
                                <SelectDropOtions
                                    options={option?.building}
                                    useTheme={false}
                                    onChange={value => handleChangeSelectOption("building", value)}
                                    value={buildingId}
                                    containerClass={`${classsDisplay?.inputDropdownText} bg-white mx-2 d-flex justify-content-center`}
                                    papperClass={`${classsDisplay.dropdownMenuText} bg-white`}
                                    placeholder="Building..."
                                    renderOption={row => {
                                        return (
                                            <MenuItem key={row?.buildingId + "_build"} value={row?.buildingId}>
                                                {row?.name}
                                            </MenuItem>
                                        );
                                    }}
                                />
                                <SelectDropOtions
                                    options={option?.floor?.filter(item => item?.buildingId === buildingId)}
                                    useTheme={false}
                                    onChange={value => handleChangeSelectOption("floor", value)}
                                    value={floorId}
                                    containerClass={`${classsDisplay?.inputDropdownText} bg-white d-flex justify-content-center`}
                                    papperClass={`${classsDisplay.dropdownMenuText} bg-white`}
                                    placeholder="Floor..."
                                    renderOption={row => {
                                        return (
                                            <MenuItem key={row?.floorId + "_floor"} value={row?.floorId}>
                                                {row?.name} {row?.locationName}
                                            </MenuItem>
                                        );
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>

                {/* content */}
                <div className="content-display overflow-hidden flex-fill px-4 d-flex align-items-center border-4 border border-dark">
                    <Grid container spacing={1} className="box-nodes-rooms h-100">
                        {nodeIdBoxRoom.map((row, idx) => {
                            return (
                                <Grid
                                    key={`nodeIdBoxRoom${idx}`}
                                    item
                                    xs={4}
                                    className={`h-100 card-room d-flex flex-column ${
                                        idx === 1 ? "border-left border-right border-5 border-dark" : ""
                                    }`}>
                                    {row.isShow ? (
                                        <RoomDetails
                                            valueZoom={valueZoom}
                                            nodeId={row.nodeId}
                                            roomObj={row?.roomObj}
                                            setSpeakTextQueue={setSpeakTextQueue}
                                        />
                                    ) : (
                                        <MenuPopoverRoom
                                            nodes={row}
                                            data={dataRoom}
                                            onClickMenu={data => {
                                                handleSelectMenuRoom(data);
                                            }}
                                        />
                                    )}
                                </Grid>
                            );
                        })}
                    </Grid>
                </div>

                {/* footer */}
                <div className="footer-text">
                    <div>
                        <Box className={classs.textMarquee}>
                            <p className={classsDisplay?.footerTextMarquee}>{movingText}</p>
                        </Box>
                    </div>
                </div>
            </div>
        </div>
    );
}
